/* global toastr:false, moment:false */
(function () {
    'use strict';

    angular
        .module('app.core')
        .constant('toastr', toastr)
        .constant('moment', moment)
        .constant('ngAuthSettings', {
            apiServiceBaseUri: '/',
            clientId: 'angular.client'
        })
        .value('Settings', {});

})();
